import { render, staticRenderFns } from "./CongestionTaxPassages.vue?vue&type=template&id=4bd7e9c6"
import script from "./CongestionTaxPassages.vue?vue&type=script&lang=js"
export * from "./CongestionTaxPassages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports